import { useState, useEffect, useRef } from 'react';

export const useComponentVisible = (initialIsVisible: boolean) => {
  const [isComponentVisible, setIsComponentVisible] = useState(
    initialIsVisible
  );
  const ref = useRef<HTMLDivElement>(null);

  const [clicked, setClicked] = useState(false);
  // console.log("isComponentVisible== ", isComponentVisible)

  // const ref = useRef<any>(null);

  // console.log("ref--- ", ref.current)

  const handleHideDropdown = (event: KeyboardEvent) => {
    if (event.key === 'Escape') {
      setIsComponentVisible(false);
      // console.log("handleHideDropdown called== ")
    }
  };

  const handleClickOutside = (event: Event) => {
    if (ref.current && !ref.current.contains(event.target as Node)) {
      setIsComponentVisible(false);
    }
  };

  const closeDropdown = () => {
    setIsComponentVisible(false)
  }

  useEffect(() => {
    document.addEventListener('keydown', handleHideDropdown, true);
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('keydown', handleHideDropdown, true);
      document.removeEventListener('click', handleClickOutside, true);
    };
  // }, [isComponentVisible, setIsComponentVisible]);
  }, []);

  return { ref, isComponentVisible, setIsComponentVisible, closeDropdown };
};
